import { render, staticRenderFns } from "./scoringComponent.vue?vue&type=template&id=a5171a50"
import script from "./scoringComponent.vue?vue&type=script&lang=js"
export * from "./scoringComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports